import React from 'react';
import classNames from 'classnames';
import Header from './components/Common/Header';
import Footer from './components/Common/Footer';
import NewSidebar from 'components/Common/NewSidebar';
import Routes from './pages/Routes';
import { BrowserRouter, useLocation } from 'react-router-dom';

import 'resources/styles/App.css';

const App: React.FC = () => {
  // const excludeLayout = false;
  const location = useLocation();
  // Define routes that should not have navbar, header, or footer
  const excludeLayout = location.pathname.includes('submit-questionnaire');
  return (
    <BrowserRouter>
      <div
        id='MainApp'className={classNames('MainApp ', { full_page: excludeLayout })}>
        {!excludeLayout &&
          <div className='SideBar-block'>
            <NewSidebar />
          </div>
        }
        <div className='right-body'>
          {!excludeLayout && <Header />}
          <Routes />
          {!excludeLayout && <Footer />}
        </div>
      </div>
    </BrowserRouter>
  );
};

export default App;
